import { Modal } from 'flowbite-react';
import { t } from 'i18next';
import { useState } from 'react';

function CertificateModal({ watch, showCertificate, amount }) {
  const [openModal, setOpenModal] = useState(false);
  const { beneName, beneMobile, senderName, senderMobile } = watch();

  return (
    <div className="flex justify-center md:justify-start">
      {/* <button
        className="focus:outline-none w-32 text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
        onClick={() => setOpenModal(true)}
      >
        {t("Certificate")}
      </button> */}
      <section className="grid justify-center">
        <Modal className="mx-96 bg-transparent " dismissible show={openModal} onClose={() => setOpenModal(false)}>
          <span className="text-3xl p-2 pl-4 font-semibold cursor-pointer " onClick={() => setOpenModal(false)}>
            X
          </span>
          <h1 className="text-4xl text-center text-customgreen my-5">{t('Certificate Details')}</h1>

          <Modal.Body>
            <div className="space-y-6">
              <p className="text-base leading-relaxed text-gray-500 ">
                {t('Beneficiary Name')}: {beneName}
              </p>
              <p className="text-base leading-relaxed text-gray-500 ">
                {t('Beneficiary Mobile')}: {beneMobile}
              </p>
              {showCertificate && (
                <p className="text-base leading-relaxed text-gray-500 ">
                  {t('Amount')}: {amount}
                </p>
              )}

              <p className="text-base leading-relaxed text-gray-500 ">
                {t('Sender Name')}: {senderName}
              </p>
              <p className="text-base leading-relaxed text-gray-500 ">
                {t('Sender Mobile')}: {senderMobile}
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="red-btn" onClick={() => setOpenModal(false)}>
              {t('Download')}
            </button>
            {/* <button className="green-btn" onClick={() => setOpenModal(false)}>
            Approve
          </button> */}
          </Modal.Footer>
        </Modal>
      </section>
    </div>
  );
}

export default CertificateModal;
